<template></template>
<script>
  const debounce = require("debounce");
  export default {
    name: "QtyButtonBase",
    props: {
      qty: {
        type: [ String, Number ],
        required: true
      },
      minQty: {
        type: [ String, Number ],
        required: false,
        default: 1
      },
      maxQty: {
        type: [ String, Number ],
        required: false,
        default: 9
      }
    },

    data() {
      return {
        touched: false,
        localQty: 1 //- use this for qty in local state for immediate updates in UI
      }
    },

    watch: {
      qty: { //- watch the qty for state updates to update localQty
        immediate: true,
        handler(val) {
          this.localQty = val;
        }
      }
    },

    computed: {
      minQtyReached() {
        return this.localQty == this.minQty;
      },

      maxQtyReached() {
        return this.localQty >= this.maxQty;
      }
    },

    methods: {
      incrementQty() {
        this.touched = true;
        if (this.maxQtyReached) {
          this.$emit('maxQtyReached');
          this.$store.dispatch('notifyWarn', 'Please contact Color Crew for larger quantities.');
          return;
        }

        ++this.localQty;
        this.sendUpdate(this.localQty);
      },

      decrementQty() {
        this.touched = true;
        if (this.minQtyReached) {
          this.$emit('minQtyReached');
          return;
        }

        --this.localQty;
        this.sendUpdate(this.localQty);
      },
      //- hold the update emit if user clicks the button multiple times in short succession
      sendUpdate: debounce(function(qty) {
        if (!qty) {
          return;
        }

        this.$emit('qtyChange', qty);
      }, 500)
    }
  }
</script>
